import React, { useState, useEffect, useRef, useContext, useCallback } from 'react';
import Intersect from '../Intersect';
import DecodeGlobalContext from '../../redux/decodeGlobalContext';
import { breakpoints } from '../../config/constants';
import { capitalize } from '../../helpers/text';

import './styles.scss';

const ArticleTransporter = ({ position, transporterRef }) => {
  const { state, dispatch } = useContext(DecodeGlobalContext);
  const [transporterVisible, setTransporterVisible] = useState(false);
  const [transporterAnimating, setTransporterAnimating] = useState(false);
  const { categoryFilter } = state;
  const intersectRef = useRef();
  const isMobileOrTablet = window.innerWidth < breakpoints.smallDesktop;
  const className = ['article-transporter', `article-transporter--${position}`]
    .concat(transporterVisible ? 'article-transporter--visible' : [])
    .concat(transporterAnimating ? 'article-transporter--animating' : [])
    .join(' ');
  const goBackText = categoryFilter.length ? capitalize(categoryFilter) : 'Homepage';

  function handleTransportButtonClick() {
    dispatch({ type: 'SET_IS_TRANSPORTED', payload: true });
    setTransporterVisible(false);
  }

  function onElementIntersection({ isIntersecting }) {
    setTransporterAnimating(isIntersecting);

    // Animate
    dispatch({
      type: 'SET_NAVIGATION_MENU_HIDDEN',
      payload: isMobileOrTablet && isIntersecting
    });
  }

  const checkLoaderAnimationEnd = useCallback(({ animationName }) => {
    if (animationName === 'loading') {
      dispatch({ type: 'SET_IS_TRANSPORTED', payload: true });
    }
  }, []);

  useEffect(() => {
    setTransporterVisible(true);
  }, []);

  return (
    <Intersect
      active
      config={{
        root: null,
        margin: '0px'
      }}
      onIntersection={entry => onElementIntersection(entry[0])}
      elementRef={intersectRef}>
      <div
        ref={transporterRef}
        id={`transporter-${position}`}
        aria-hidden={position === 'start'}
        className={className}>
        <span ref={intersectRef} className="article-transporter__intersect-ref" />
        <div id={`progress-background-${position}`} className="article-transporter__background" />
        <div id={`progress-wrapper-${position}`} className="article-transporter__wrapper">
          <button
            id={`progress-button-${position}`}
            tabIndex={`${position === 'start' ? -1 : ''}`}
            title={`Click to go back to ${goBackText}`}
            onClick={e => {
              handleTransportButtonClick(e);
            }}
            type="button"
            className="article-transporter__redirect-button">
            <svg className="article-transporter__circle" width="100px" height="100px">
              <circle cx="50" cy="50" r="48" className="article-transporter__shape" />
              <circle
                cx="50"
                cy="50"
                r="48"
                className="article-transporter__shape article-transporter__shape--animating"
                onAnimationEnd={checkLoaderAnimationEnd}
              />
            </svg>
          </button>
          <button
            type="button"
            tabIndex={`${position === 'start' ? -1 : ''}`}
            onClick={e => {
              handleTransportButtonClick(e);
            }}
            className="article-transporter__copy">
            {`Back to ${goBackText}`}
          </button>
        </div>
      </div>
    </Intersect>
  );
};

export default ArticleTransporter;
